<div class="p-3 w-full max-w-72 h-full space-y-2">
    <!-- Search -->
    <div class="w-full">
        <ng-select #employeeSelect class="custom-select-field" [items]="employees | async" [multiple]="true"
            [loading]="employeeFetching" appendTo="body" [closeOnSelect]="false" [typeahead]="employeeValueSubject" (open)="onEmployeeSelectOpen()"
            (clear)="onEmployeeClear()" (scrollToEnd)="onEmployeeScrollToEnd()" [searchable]="true" (close)="employeeSelect.blur()"
            placeholder="{{'text.search_user' | translate}}" [clearable]="false" [hideSelected]="false">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <div class="primary-font text-base flex items-center" (click)="onEmployeeChange(item)">
                    <input #assignmentStatus id="item-{{index}}" type="checkbox" class="mr-4" [checked]="isEmployeeAssigned(item)" />
                    <div class="primary-font text-base text-gray-700 font-normal flex items-center w-full truncate">
                        <img *ngIf="item?.hasValidProfilePicture" class="relative rounded-md mr-2"
                            [ngClass]="showUserTeamAndRole?'h-10 w-10': 'h-8 w-8'" src="{{item?.user?.profile_picture}}"
                            alt="{{item?.user?.first_name}} {{item?.user?.last_name ?? ''}}"
                            title="{{item?.user?.first_name}} {{item?.user?.last_name ?? ''}}">
                        <div *ngIf="!item?.hasValidProfilePicture"
                            matTooltip="{{item?.user?.first_name}} {{item?.user?.last_name ?? ''}}"
                            class="flex flex-shrink-0 bg-gray-200 rounded-md items-center text-base justify-center mr-2"
                            [ngClass]="showUserTeamAndRole?'h-10 w-10': 'h-8 w-8'">
                            {{item?.user?.first_name[0]}}
                        </div>
                        <div class="w-2/3 truncate">
                            <p class="text-base font-medium cursor-default block truncate"
                                title="{{item?.user?.first_name}} {{item?.user?.last_name ?? ''}}">
                                {{item?.user?.first_name}} {{item?.user?.last_name ?? ''}}
                            </p>
                            <p class="text-md truncate cursor-default" *ngIf="(item?.team || item?.user?.role) && showUserTeamAndRole">
                                <span class="pr-2" *ngIf="item?.user?.role"
                                    title="{{item?.user?.role?.role_name}}">{{item?.user?.role?.role_name}}</span>
                                <span class="border-l border-gray-400 pl-2" *ngIf="item?.team?.team_name"
                                    title="{{item?.team?.team_name}}">{{item?.team?.team_name}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template ng-multi-label-tmp>
                <span style="display:block" *ngIf="!employeePagination.keyword"
                    class="ng-placeholder">{{'text.search_user' |
                    translate}}</span>
            </ng-template>
            <ng-template ng-footer-tmp *ngIf="employeeSelect?.itemsList?.items?.length">
                <div class="flex justify-end">
                    <button type="button"
                    (click)="employeeSelect.close()"
                    class="px-6 items-center py-2 border b-1 border-gray-300 text-black shadow-sm text-base primary-font rounded-md bg-white hover:bg-gray-100">
                    {{'dashboard.remove.widget.confirm' | translate }}</button>
                </div>
            </ng-template>
        </ng-select>
    </div>

    <!-- Employee list -->
    <div *ngIf="assignedEmployees?.length" class="primary-font px-2 text-base text-gray-700 font-normal">{{'text.selected_users' | translate}}: {{assignedEmployees.length}}</div>
    <div class="divide-y divide-gray-200 max-h-32 overflow-y-auto zuper-scrollbar"
        *ngIf="assignedEmployees?.length">
        <ng-container *ngFor="let element of assignedEmployees;let i=index">
            <div class="flex items-center py-1.5" *ngIf="element?.user">
                <img *ngIf="element?.user?.hasValidProfilePicture" class="relative rounded-md mr-2"
                    [ngClass]="showUserTeamAndRole?'h-10 w-10': 'h-8 w-8'"
                    src="{{element?.user?.profile_picture}}" alt="{{element?.user?.first_name}} {{element?.user?.last_name ?? ''}}"
                    title="{{element?.user?.first_name}} {{element?.user?.last_name ?? ''}}">
                <div *ngIf="!element?.user?.hasValidProfilePicture" matTooltip="{{element?.user?.first_name}} {{element?.user?.last_name ?? ''}}"
                    class="flex flex-shrink-0 bg-gray-200 rounded-md items-center text-base justify-center mr-2" [ngClass]="showUserTeamAndRole?'h-10 w-10': 'h-8 w-8'">
                    {{element?.user?.first_name[0]}}
                </div>
                <div class="w-2/3 truncate">
                    <p class="text-base font-medium cursor-default block truncate"
                        title="{{element?.user?.first_name}} {{element?.user?.last_name ?? ''}}">
                        {{element?.user?.first_name}} {{element?.user?.last_name ?? ''}}
                    </p>
                    <p class="text-md truncate cursor-default" *ngIf="(element?.team || element?.user?.role) && showUserTeamAndRole">
                        <span class="pr-2" *ngIf="element?.user?.role"
                            title="{{element?.user?.role?.role_name}}">{{element?.user?.role?.role_name}}</span>
                        <span class="border-l border-gray-400 pl-2" *ngIf="element?.team?.team_name"
                            title="{{element?.team?.team_name}}">{{element?.team?.team_name}}</span>
                    </p>
                </div>
                <div class="flex ml-auto items-center">
                    <a matTooltip="{{'text.unassign' | translate}}" (click)="unassignEmployee(element)"
                        class="flex flex-shrink-0 hover:bg-red-100 rounded-full items-center justify-center h-8 w-8 cursor-pointer">
                        <em class="ti ti-user-x text-xl text-red-500"></em>
                    </a>
                </div>
            </div>
        </ng-container>
    </div>

    <div *ngIf="!assignedEmployees?.length" class="primary-font px-2 text-base text-gray-700 font-normal">{{'text.no_users_selected' | translate}}</div>

    <!-- Footer action button -->
    <div class="w-full flex items-center space-x-2" >
        <button type="button" (click)="onCancelAssignEmployees()"
        class="px-4 items-center text-base py-1 ml-auto w-1/2 border b-1 border-gray-300 text-black shadow-sm font-small rounded-md  bg-white focus:outline-none btn-small">
        {{'cancel.text' | translate}}</button>
        <button (click)="onSaveEmployess()"
            class="bg-primary btn-small px-4 w-1/2 items-center py-1 border b-1 shadow-sm text-white text-base font-medium rounded-md text-white-600">
            {{'text.save' | translate}}
        </button>
    </div>
</div>